// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalContentSplitter_container__2BaOx","line":"ModalContentSplitter_line__12EHI"};